import {
  Box,
  Container,
  Flex,
  Heading,
  Link,
  Text,
  VStack,
  useColorModeValue,
} from '@chakra-ui/react';
import { FaGithub } from 'react-icons/fa';

function Footer() {
  const bgColor = useColorModeValue('rgba(255, 255, 255, 0.95)', 'dark.900');
  const borderColor = useColorModeValue('tint.200', 'dark.700');
  const subtleBorderColor = useColorModeValue('tint.100', 'dark.800');
  const textColor = useColorModeValue('gray.600', 'gray.400');

  return (
    <Box
      as="footer"
      borderTop="1px solid"
      borderColor={borderColor}
      pt={12}
      pb={8}
      bg={bgColor}
    >
      <Container maxW="1120px">
        <Flex
          flexWrap="wrap"
          gap={6}
          justify="space-between"
          mb={6}
        >
          <VStack align="start" spacing={2}>
            <Heading as="h3" fontSize={{ base: 'md', md: 'lg' }}>
              Impicom
            </Heading>
            <Text color={textColor} fontSize={{ base: 'xs', md: 'sm' }}>
              Importaciones internacionales sin complicaciones.
            </Text>
          </VStack>

          <VStack align={{ base: 'start', md: 'end' }} spacing={1}>
            <Text color={textColor} fontSize={{ base: 'xs', md: 'sm' }}>
              Oficina 1403 edificio banco de bogota
            </Text>
            <Text color={textColor} fontSize={{ base: 'xs', md: 'sm' }}>
              Santa Marta, Magdalena
            </Text>
            <Text color={textColor} fontSize={{ base: 'xs', md: 'sm' }} mt={2}>
              Tel: +57 3133203931
            </Text>
            <Text color={textColor} fontSize={{ base: 'xs', md: 'sm' }}>
              impicomimportaciones@gmail.com
            </Text>
          </VStack>
        </Flex>

        <Box textAlign="center" pt={6} borderTop="1px solid" borderColor={subtleBorderColor}>
          <Text color="gray.500" fontSize={{ base: 'xs', md: 'sm' }}>
            2026 Impicom. Todos los derechos reservados.
          </Text>
          <Flex justify="center" align="center" gap={2} mt={3}>
            <Text color="gray.500" fontSize={{ base: 'xs', md: 'sm' }}>
              Desarrollado por
            </Text>
            <Link
              href="https://github.com/Andres-brek"
              isExternal
              display="flex"
              alignItems="center"
              gap={1}
              color="gray.400"
              _hover={{ color: 'white' }}
              transition="color 0.2s"
            >
              <FaGithub size={16} />
              <Text fontSize={{ base: 'xs', md: 'sm' }}>Andres-brek</Text>
            </Link>
          </Flex>
        </Box>
      </Container>
    </Box>
  );
}

export default Footer;
